import { Link } from "react-router-dom";
import styled from "styled-components";

export const PasoBarContainer = styled.div`
  width: 100%;
  margin: 25px 0;
  position: relative;
`;

export const PasoBarLinea = styled.div`
  width: 100%;
  height: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-latex10);
`;

export const PasoBarLineaProgreso = styled.div`
  width: ${({ $pasoActual }) => {
    if ($pasoActual === "MedicoSolicitante") return "0%";
    else if ($pasoActual === "SubirOrden") return "34%";
    else if ($pasoActual === "AbonarMP") return "67%";
    else if ($pasoActual === "ValidarCobertura") return "100%";
    else return "0%";
  }};
  height: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 0;
  background-color: var(--color-broccoli);
`;

export const PasoBarCirculo = styled.div`
  background-color: var(--color-latex10);
  border-radius: 50%;
  height: 18px;
  width: 18px;
  z-index: 10;
`;

export const PasoBarCirculoCompleto = styled.div`
  background-color: var(--color-broccoli);
  border-radius: 50%;
  height: 18px;
  width: 18px;
  z-index: 10;
`;

export const PasoBarCirculoActivo = styled.div`
  background-color: var(--color-latex10);
  border: 2px solid var(--color-broccoli);
  border-radius: 50%;
  height: 18px;
  width: 18px;
  z-index: 10;
`;
